<template>
  <div class="wrap">
    <div
      v-for="(pitem,pindex) in appList"
      :key="pindex"
      class="app-type-box"
    >
      <div class="app-type">
        <span class="app-type-text">{{ pitem.classifyName }}</span>
      </div>
      <div class="app-box">
        <div
          v-for="(item,index) in pitem.list"
          :key="index"
          class="app-item"
          :style="{backgroundImage:'url('+item.productIcon+')'}"
        >
          <div class="app-name">
            {{ item.productName }}
          </div>
          <div class="app-intro">
            {{ item.productMemo }}
          </div>
          <div class="app-footer">
            <button
              class="buy-btn"
              @click="goOrder(item)"
            >
              立即订购
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  components: {
  },
  data(){
    return {
      appList: {},
    };
  },
  created(){
    // 查询商品列表
    this.getListAllProductOnline();
  },
  mounted() {

  },
  methods: {
    // 查询商品列表
    getListAllProductOnline(){
      const url = '/paycenter-charge/api/facade/product/listAllProductOnline';
      this.$http.get(url).then(res=>{
        if (res.success){
          this.appList = res.data;
        } else {
          this.$Message.warning(res.message||'请求失败');
        }
      });
    },
    goOrder(item){
      this.$router.push({
        path: '/standardProduct/productVersion/index',
        query: {
          productCode: item.productCode,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrap {
  width: 1200px;
  margin: 0 auto;
  // margin-top: 20px;
}
.app-type-box {
  margin-bottom: 10px;
  font-weight: bold;
}
.app-type {
  font-size: 18px;
  color: #1b1c26;
  margin-bottom: 10px;
  font-weight: 700;
  // font-weight: 700;
  .app-type-text {
    display: inline-block;
    padding: 10px 0;
  }
}
.app-box {
  display: flex;
  // justify-content: center;
  flex-wrap: wrap;
  width: 1230px;
  margin-left: -15px;
  .app-item {
    box-sizing: border-box;
    width: 280px;
    height: 160px;
    // flex-shrink: 0;
    margin: 12px;
    box-shadow: 0 0 15px 1px #ddd;
    padding: 15px 25px 25px;
    border-radius: 5px;
    position: relative;
    transition: all ease 300ms;
    background-size: 100% 100%;
    // background-image: url();
    &:nth-child(3n+1) {
      background-color: #1a89ff;
    }
    &:nth-child(3n+2) {
      background-color: #8654ff;
    }
    &:nth-child(3n) {
      background-color: #4e74f0;
    }
    &:hover {
      box-shadow: 0 0 15px 1px #ddd;
      // box-shadow: 0 10px 20px 0 rgb(0 0 0 / 10%);
      transform: translateY(-5px);
    }
    .app-name {
      font-size: 18px;
      font-weight: bold;
      color: #fff;
      margin-bottom: 10px;
      overflow: hidden;
      text-overflow: -o-ellipsis-lastline;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .app-intro {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
      // margin-bottom: 20px;
      // width: 85%;
      overflow: hidden;
      text-overflow: -o-ellipsis-lastline;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .app-footer {
      position: absolute;
      bottom: 20px;
    }
    .buy-btn {
      color: #fff;
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.2);
      padding: 6px 12px;
      line-height: 1;
      border: 0;
      font-size: 14px;
    }
    .app-logo {
      display: block;
      // border: 0;
      position: absolute;
      width: 34px;
      height: 34px;
      right: 25px;
      top: 19px;
      border-radius: 100%;
    }
  }
}

</style>
